export default "__VITE_ASSET__Dzdgsjjq__"